import React from 'react';

import styled from 'styled-components';

import { CMASummaryFilters } from 'components/CMASummary/types';
import { useCommunityViewContext } from 'components/View/CommunityViewContext';

import { COMMUNITY_CONTRACT_SELECTION_TYPE, CONTRACT_DISPLAY_TYPES } from '../../../../constants';

const Label = styled.span<{ fontFamily: string }>`
  font-family: ${({ fontFamily }) => fontFamily};
`;

type Props = {
  contractDisplayType?: number;
  contractSelectionType?: number;
};

const CMASummaryContractsFilterLabel = (props: Props = {}) => {
  const { viewFilters } = useCommunityViewContext();
  const filters = viewFilters as CMASummaryFilters;

  const effectiveContractDisplayType = props.contractDisplayType ?? filters.contractDisplayType;
  const effectiveContractSelectionType = props.contractSelectionType ?? filters.contractSelectionType;

  const selectionLabel =
    effectiveContractSelectionType === COMMUNITY_CONTRACT_SELECTION_TYPE.APPROXIMATE ? 'Approximate' : 'Exact';
  const description =
    effectiveContractDisplayType === CONTRACT_DISPLAY_TYPES.EVERYONES_CONTRACTS
      ? "Everyone's"
      : `My, ${selectionLabel}`;

  return (
    <>
      <Label fontFamily="var(--font-bold)">Contract Type: </Label>
      {description}
    </>
  );
};

export default CMASummaryContractsFilterLabel;
